import { render, staticRenderFns } from "./chainPage4.vue?vue&type=template&id=7bd704f0&scoped=true"
import script from "./chainPage4.vue?vue&type=script&lang=js"
export * from "./chainPage4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd704f0",
  null
  
)

export default component.exports